import styles from './EnrollNowButton.module.scss';
import { IModalActions, ModalTypes } from '@/types/modal';
import { useContext } from 'react';
import { ModalContext } from '@/context/ModalContext';
import { pushToDataLayer } from '@/helpers/gtag';
import { getGlobalStateValue } from '@/context/utils';
import { usePathname } from 'next/navigation';

export default function EnrollNowButton({ associatedPrograms }) {
  const { modalDispatch } = useContext(ModalContext);

  const path = usePathname();
  const isAfricaPage = path == "/africa"  

  if(isAfricaPage){
    return null;
  }

  const applyNowCTA = () => { 
    const Custom10PgType = associatedPrograms[0]?.attributes?.BasicDetails?.Custom10PgType || '';
    const specializationText = associatedPrograms[0]?.attributes?.BasicDetails?.SpecializationText || '';
    const brochure =  associatedPrograms[0]?.attributes?.BasicDetails?.Brochure?.data?.attributes?.url || '';
    const programDetails = associatedPrograms[0]?.attributes?.BasicDetails
    
    pushToDataLayer({
      event: "lead_initiate",
      cta_text: 'Apply now',
      section_name: "Bottom Navigation Bar",
      header_title: "NA",
      page_type: getGlobalStateValue('pageType')
    });

    modalDispatch ({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.LandingPageConnectModalTempleteOne,
        modalData: { specializationText, Custom10PgType, brochure, isMobile: true, programDetails, associatedPrograms, isLandingPage: true },
      }}
    );
  }

  return (
    <div className={styles.enrollCTAContainer} id="enroll-now-button-cta" >
        <div onClick={applyNowCTA} className={styles.enrollCTAContainerInner}>Apply now &#8594;</div>
    </div>
  )
}
